import React from 'react';
import { useDispatch } from 'react-redux';
import styles from '../../../../styles/modules/components/logout-modal.module.scss';
import UIModal from '../../../common/ui-components/surface/UIModal';
import Button from '../../../common/ui-components/input/Button';
import { SignOut } from '../../../../api/myaccount';
import Cookies from 'js-cookie';
import { deleteCart } from '../../../../redux/actions/cartActions';
import { setSignOutAlert, setIsAuthenticate } from '../../../../redux/actions/customerActions';
import { connect } from "react-redux";
import { cleverTapTrigger } from '../../../../tracking/segment';



const LogoutModal = (props:any) => {

  const onConfirm = () => {
    props.deleteCart(false)
    SignOut()
      .then(() => {
        cleverTapTrigger("Logout - Button Clicked",{"CTA":"YES"})
       props.setSignOutAlert(false);
        props.setIsAuthenticate(false);
        props.deleteCart(false)
        Cookies.remove('is_authenticate');
        Cookies.remove('customer_personal_details');
        window.location.href = window.location.origin;
      })
      .catch((err: any) => {
        console.log('Logout error =>', err);
      });
      props.setLogoutModalVisible(false);
        props.setFindModalVisible(false);
  };

  const onCancel = () => {
    cleverTapTrigger("Logout - Button Clicked",{"CTA":"NO"})
    props.setLogoutModalVisible(false);
    props.setFindModalVisible(true);
  };

  return (
     <UIModal isOpen={props.isOpen} onClick={onCancel} boxClass={styles.modalBox}>
      <div className={styles.logoutContainer}>
        <h3 className={styles.logoutTitle}>Logout</h3>
        <p className={styles.logoutMessage}>
          Select <strong>'Yes'</strong> to logout and sign in with the number used during purchase.
        </p>
        <div className={styles.buttonGroup}>
          <Button text="YES" onClick={onConfirm} className={styles.button} />
          <Button text="NO" onClick={onCancel} className={styles.button} />
        </div>
      </div>
    </UIModal>
  );
};



const mapDispatchToProps = (dispatch: any) => {
  return {
    setSignOutAlert: (data: any) => dispatch(setSignOutAlert(data)),
    setIsAuthenticate: (data: any) => dispatch(setIsAuthenticate(data)),
    deleteCart: (preserveType:boolean) => dispatch(deleteCart(preserveType))
  };
};

export default connect(null,mapDispatchToProps)(LogoutModal);